<div id="app-bar" style="height:40px !important;" [ngClass]="{'padded-appbar': isVisible}">
  <app-bar [userName]="userName" [organizationName]="organizationName" [isVisible]="isVisible"></app-bar>
</div>

<kendo-drawer-container id="navDrawerMenu">
  <kendo-drawer id="drawer" #drawer
                [items]="items"
                [mini]="true"
                mode="push"
                [autoCollapse]="false"
                [(expanded)]="expanded"
                (select)="onSelect($event)">
  </kendo-drawer>
  <kendo-drawer-content>
    <app-feedback-messages></app-feedback-messages>
    <div #feedback id="feedback-section" [hidden]="!needsToChangePassword" role="alert" class="alert alert-warning" style="text-align:left;">
      Attention! Your password has expired. Please navigate to your profile and update your password. Thank you!
    </div>
    <div class="routerOutletContainer" [@fadeAnimation]="outlet.isActivated ? outlet.activatedRoute : ''" kendoDialogContainer kendoWindowContainer>

      <router-outlet #outlet="outlet"></router-outlet>
    </div>
  </kendo-drawer-content>
</kendo-drawer-container>


<!--<app-footer-bar id="footer" [hidden]="!isVisible" [organizationName]="organizationName"></app-footer-bar>-->


